import React from 'react';
import { motion } from 'framer-motion';
const images = ['https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1574096079513-d8259312b785?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1560624052-449f5ddf0c31?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?auto=format&fit=crop&q=80&w=800'];
export function Gallery() {
  return <section id="gallery" className="py-16 md:py-24 bg-obsidian" data-id="element-59">
      <div className="max-w-7xl mx-auto px-8" data-id="element-60">
        <div className="text-center mb-12 md:mb-16" data-id="element-61">
          <h2 className="text-5xl font-serif text-white mb-4 italic" data-id="element-62">
            The Gallery
          </h2>
          <div className="w-24 h-[1px] bg-champagne mx-auto opacity-50" data-id="element-63" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-64">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative group cursor-pointer overflow-hidden aspect-[3/4]" data-id="element-65">
              <img src={img} alt={`Gallery ${index}`} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-66" />
              <div className="absolute inset-0 border-0 group-hover:border-[1px] border-champagne transition-all duration-500 z-10" data-id="element-67" />
              <div className="absolute inset-0 bg-obsidian/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center" data-id="element-68">
                <span className="text-xs md:text-sm uppercase tracking-[0.4em] text-champagne font-serif" data-id="element-69">
                  View Moment
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}